import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { INTANGIBLE_KEY, QUERY_PARAMS, URL_ROUTES } from '@/constants';
import { redirectToUrl } from '@/modules/perseo-billing/utils/window';
import { getQueryParam } from '@/modules/shared/utils/deviceDetections';
import { isWeddingFlow } from '@/modules/shared/utils/isWeddingFlow';

const shippingRoute = URL_ROUTES.SHIPPING;
const isWedding = isWeddingFlow();

const getShippingUrl = () => {
  const device = getQueryParam(QUERY_PARAMS.DEVICE);
  const isNotDevice = !device || device === 'web';
  if (isNotDevice) return shippingRoute;

  return `${shippingRoute}?device=${device}`;
};

export const UseBillingGuard = () => {
  const { data: cart } = useAppSelector((state) => state.cart);
  const navigate = useNavigate();

  useEffect(() => {
    if (isWedding) return;
    const hasCart = !!cart?.id;
    if (!hasCart) return;

    const hasShippingAddress = !!cart?.shippingAddress?.alias;
    const hasDeliveryInfo = cart?.deliveryInfo?.deliveryGroups?.length ?? 0 > 0;

    const isEmptyCart = cart?.lineItems?.length === 0;
    if (isEmptyCart) {
      redirectToUrl(URL_ROUTES.CART);
      return;
    }

    const isEveryProductIntangible = cart?.lineItems?.every(
      (item) => item?.productType?.key === INTANGIBLE_KEY
    );
    if (isEveryProductIntangible) return;

    if (hasCart && (!hasShippingAddress || !hasDeliveryInfo)) {
      const shippingUrl = getShippingUrl();
      return navigate(shippingUrl);
    }
  }, [cart, navigate]);
};
